export var ODGlobalTheme
;(function (ODGlobalTheme) {
  ODGlobalTheme['Default'] = 'default'
  ODGlobalTheme['CoreUILike'] = 'cui'
})(ODGlobalTheme || (ODGlobalTheme = {}))
//# sourceMappingURL=globalLayoutInterfaces.js.map
